export const DebtorType = {
  BUSINESS: 'business',
  CUSTOMER: 'customer'
};

export const DEBTOR_TYPES = Object.values(DebtorType);

export default DebtorType;
